@if (orderDeliveryBannerVideosExp()) {
  <section class="tw-mx-4 tw-p-4 tw-rounded-3 tw-bg-gray-75 tw-shadow-z4 tw-flex tw-flex-col tw-gap-5 tw-overflow-hidden" (click)="navigateToInstructions()">
    <div class="tw-flex tw-items-center tw-gap-3">
      <div class="tw-flex-none tw-w-18 tw-h-14 tw-rounded-2 tw-overflow-hidden tw-bg-[#F9E7D7]">
        <img class="tw-w-full tw-h-full tw-object-cover" [src]="kitImage" alt="" />
      </div>
      <div class="tw-font-lexend tw-font-bold tw-text-500 tw-leading-[22px] tw-text-black">
        @if (kitClass === ApiClientConstant.Regimen.Class.HAIR) {
          <span i18n="@@yourHairKitIsDelivered"><span class="tw-capitalize">{{titlePrefix}}</span>your hair kit is delivered</span>
        } @else if (kitClass === ApiClientConstant.Regimen.Class.FACE) {
          <span i18n="@@yourSkinKitIsDelivered"><span class="tw-capitalize">{{titlePrefix}}</span>your skin kit is delivered</span>
        } @else {
          <span i18n="@@yourTreatmentKitIsDelivered"><span class="tw-capitalize">{{titlePrefix}}</span>your treatment kit is delivered</span>
        }
        <img class="tw-inline-block tw-w-5 tw-h-5 tw-ml-1 tw-align-middle tw-mix-blend-multiply" src="/assets/gifs/kit-delivered-sparkle.gif" alt="" />
      </div>
    </div>

    <div class="tw-flex tw-flex-col tw-gap-2">
      <div class="tw-flex tw-items-center tw-justify-between">
        <p class="tw-font-body tw-italic tw-text-200 tw-text-gray-500" i18n="@@learnHowToUseYourProducts">Learn how to use your products</p>
        <cs-icon class="tw-h-3 tw-w-3 tw-flex-none tw-text-teal-600" [iconName]="'chevron_right_teal'"></cs-icon>
      </div>

      @if (showVideoCarousel) {
        <div (click)="$event.stopPropagation()">
          <swiper [config]="swiperConfig" class="tw-w-[calc(100%+32px)] -tw-mx-4">
            @for (video of instructionVideos; track video.url; let i = $index) {
              <div *swiperSlide
                class="tw-relative tw-w-[104px] tw-h-32 tw-rounded-2 tw-overflow-hidden tw-flex-shrink-0"
                [style.background-color]="videoCardBackgrounds[i % videoCardBackgrounds.length]"
                (click)="playVideo(video)">
                @if (video.posterFromTag) {
                  <!-- curated regimen-delivered-banner image: fills the card -->
                  <img class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover" [src]="video.poster" alt="poster" />
                } @else {
                  <!-- legacy product image: centered, fixed height -->
                  <img class="tw-absolute tw-left-1/2 -tw-translate-x-1/2 tw-top-2.5 tw-h-[108px] tw-max-w-full tw-object-contain" [src]="video.poster" alt="poster" />
                }
                <div class="tw-absolute tw-inset-0 tw-mix-blend-multiply tw-bg-gradient-video-card-scrim"></div>
                <div class="tw-absolute tw-top-1 tw-left-1 tw-w-[56px] tw-h-[16px] tw-flex tw-items-center tw-justify-center tw-rounded-1 tw-bg-[#FEFEFECC] tw-border-[0.5px] tw-border-solid tw-border-gray-75 tw-backdrop-blur-[10px]">
                  <p class="tw-font-body tw-font-medium tw-text-50 tw-leading-[10px] tw-tracking-[0.08px] tw-text-black tw-whitespace-nowrap tw-uppercase" i18n="@@productNumberTag">Product {{ i + 1 }}</p>
                </div>
                <img class="tw-absolute tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-w-5 tw-h-5" src="/assets/images/order-delivery-play.svg" alt="" />
                @if (video.durationLabel) {
                  <p class="tw-absolute tw-bottom-1 tw-left-1 tw-font-body tw-font-bold tw-text-50 tw-leading-[10px] tw-text-gray-75">{{ video.durationLabel }}</p>
                }
              </div>
            }
            @if (showSeeMoreInstructionsTile) {
              <div *swiperSlide class="tw-w-[104px] tw-h-32 tw-rounded-2 tw-flex-shrink-0 tw-bg-gray-75 tw-border tw-border-solid tw-border-teal-600 tw-flex tw-items-center tw-justify-center" (click)="navigateToInstructions()">
                <p class="tw-font-lexend tw-font-semibold tw-text-200 tw-leading-tight tw-text-teal-600 tw-text-center" i18n="@@seeMoreInstructions">See More Instructions</p>
              </div>
            }
          </swiper>
        </div>
      }
    </div>
  </section>

  <div class="tw-fixed tw-inset-0 tw-hidden tw-z-[120] tw-bg-black">
    <video class="tw-h-full tw-w-full tw-object-contain" #bannerVideoPlayer controls playsinline disablepictureinpicture controlslist="nodownload noremoteplayback"></video>
    <div class="tw-absolute tw-top-5 tw-right-2 tw-h-8 tw-w-8 tw-rounded-full tw-bg-black/40 tw-text-white tw-font-bold tw-text-500 tw-z-10 tw-flex tw-justify-center tw-items-center" (click)="closeVideo()">✕</div>
  </div>
} @else {
  <section class="tw-rounded-3 tw-mx-4 tw-px-2 tw-py-3 tw-border-[2px] tw-border-solid tw-border-teal-200 tw-max-h-18 tw-box-border" style="background: linear-gradient(95deg, #E4F4F0 -6.23%, #FFF 88%);" [routerLink]="orderUrl" (click)="handleClick()">
    @if (shouldShowPartialOrderCancellationUI) {
      <div class="header tw-flex tw-items-center">
        <div class="tw-relative tw-flex-none tw-h-12 tw-w-12 tw-rounded-lg tw-border tw-border-gray-200 tw-overflow-hidden tw-bg-gray-100">
          @for (image of productImages; track image; let i = $index) {
            <img
              class="tw-absolute tw-inset-1 tw-h-10 tw-w-10 tw-object-contain tw-transition-opacity tw-duration-500"
              [src]="image"
              [class.tw-opacity-100]="i === currentImageIndex"
              [class.tw-opacity-0]="i !== currentImageIndex"
              />
          }
        </div>
        <div class="tw-ml-2 tw-flex tw-flex-col tw-justify-center tw-gap-1">
          <div class="tw-leading-4 tw-font-body tw-font-bold tw-text-[14px] tw-items-center tw-flex">
            <span i18n="@@partialProductsDeliveredExpTag">{{orderedProductsCount}}/{{totalProductsCount}} Products delivered</span>
            <cs-icon class="tw-h-4 tw-aspect-square tw-ml-2 tw-flex-none" [iconName]="'chevron_right_teal'"></cs-icon>
          </div>
          @if (cancelledProducts?.length === 1) {
            <p class="tw-text-200 tw-text-orange-500 tw-font-medium" i18n="@@productRemovedByYourDoctor">{{cancelledProducts?.length}} product removed by your doctor </p>
          } @else if (cancelledProducts?.length > 1) {
            <p class="tw-text-200 tw-text-orange-500 tw-font-medium" i18n="@@productsRemovedByYourDoctor">{{cancelledProducts?.length}} products removed by your doctor </p>
          }
        </div>
      </div>
    } @else {
      <div class="header tw-flex tw-items-center tw-mt-[-2px]">
        <div class="tw-relative tw-flex-none tw-h-12 tw-w-12 tw-overflow-hidden tw-bg-gray-100"
          [ngClass]="order.type === EntityEnum.Order.Type.REGIMEN ? 'tw-rounded-1.5 tw-border tw-border-white' : 'tw-rounded-lg tw-border tw-border-gray-200'">
          @for (image of productImages; track image; let i = $index) {
            <img
              class="tw-absolute tw-transition-opacity tw-duration-500"
              [ngClass]="order.type === EntityEnum.Order.Type.REGIMEN ? 'tw-inset-0 tw-w-full tw-h-full tw-object-cover' : 'tw-inset-1 tw-h-10 tw-w-10 tw-object-contain'"
              [src]="image"
              [class.tw-opacity-100]="i === currentImageIndex"
              [class.tw-opacity-0]="i !== currentImageIndex"
              />
          }
        </div>
        <div class="tw-ml-2 tw-flex tw-flex-col tw-justify-center tw-gap-1">
          <div class="tw-leading-4 tw-font-body tw-font-bold tw-text-[14px] tw-items-center tw-flex">
            @if (order.type === EntityEnum.Order.Type.REGIMEN) {
              <span i18n="@@treatmentKitDeliveredExpTag">Treatment Kit delivered</span>
            }
            @if (order.type !== EntityEnum.Order.Type.REGIMEN) {
              <span>
                @if (orderedProductsCount === 1) {
                  <span i18n="@@oneProductDeliveredExpTag">{{orderedProductsCount}} Product Delivered</span>
                } @else {
                  <span i18n="@@multipleProductsDeliveredExpTag">{{orderedProductsCount}} Products Delivered</span>
                }
              </span>
            }
            <cs-icon class="tw-h-4 tw-aspect-square tw-ml-2 tw-flex-none" [iconName]="'chevron_right_teal'"></cs-icon>
          </div>
          <div class="tw-leading-[18px] tw-font-body tw-text-gray-500 tw-font-medium tw-text-[12px] tw-items-center tw-flex" i18n="@@clickHereToSeeDetails">
            Click here to see details
          </div>
        </div>
      </div>
    }
  </section>
}
